import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageLayoutComponent, TitileNavbarComponent } from '@ui-components';

@Component({
  selector: 'lib-rank-qa',
  templateUrl: './rank-qa.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, PageLayoutComponent]
})
export class RankQaComponent {}
